import axios from "axios";

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
const limpar = (p) => Object.fromEntries(Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== ""));

export async function carregarCupons(params) {
  const { data } = await axios.get("/api/reports/offers/coupons", { ...auth(), params: limpar(params) });
  return data;
}

export async function carregarCupom(chave, params) {
  const { data } = await axios.get(`/api/reports/offers/coupons/${encodeURIComponent(chave)}`, { ...auth(), params: limpar(params) });
  return data;
}
